import styled from 'styled-components';

export const HoleNumberTitle = styled.div`
  width: 7rem;
  height: 2rem;
  padding-right: 1rem;
  text-align: right;
  font-size: 1.5rem;
  margin-top: 0.25rem;
`;

export const HoleParTitle = styled.div`
  width: 6rem;
  height: 2rem;
  padding-right: 1rem;
  font-size: 1.5rem;
  margin-top: 0.25rem;
`;

export const HoleSITitle = styled.div`
  width: 6rem;
  height: 2rem;
  padding-right: 1rem;
  font-size: 1.5rem;
  margin-top: 0.25rem;
  color: red;
`;

export const HoleNumber = styled.div`
  width: 4rem;
  height: 2rem;
  padding-right: 1rem;
  text-align: right;
  font-size: 1.5rem;
  margin-top: 0.25rem;
`;
export const HolePar = styled.div`
  width: 2rem;
  height: 2rem;
  padding: 0;
  text-align: center;
  border: solid 1px black;
  font-size: 1.5rem;
  margin-top: 0.25rem;
`;
export const HoleStrokeIndex = styled(HolePar)`
  color: red;
`;
export const ErrorMessage = styled.div`
  margin: 0.5rem 0;
  font-size: 1rem;
  color: red;
`;
export const NameWrapper = styled.div`
  font-size: 1.5rem;
  margin: 0.25rem;
  display: flex;
  justify-content: start;
  flex-direction: row;
  input {
    font-size: inherit;
    margin-left: 0.25rem;
  }
`;
export const TotalWrapper = styled.div`
  display: flex;
  justify-content: start;
  flex-direction: row;
  align-items: center;
  font-size: 1.5rem;
  border-bottom: 1px solid black;
  border-top: 1px solid black;
  margin: 0.25rem;
`;
export const Total = styled.div`
  margin-left: 6.5rem;
  font-size: 1.5rem;
`;
export const TotalText = styled.div`
  width: 3rem;
  margin-left: 0.5rem;
`;
export const FlexRow = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: row;
  align-items: center;
  margin-left: 1rem;
`;
export const CrementButton = styled.button`
  width: 1.25rem;
  height: 2rem;
  padding: 0;
  text-align: center;
  border: solid 1px black;
  font-size: 1.25rem;
  margin-top: 0.25rem;
  background-color: aliceblue;
`;

export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: space-evenly;
  margin: 1rem;
  position: relative;
`;

export const Button = styled.button`
  border-radius: 5px;
  background: lightblue;
  border: 1px solid #5c9db2;
  font-weight: 500;
  color: white;
  height: 1.5rem;
  min-width: 5rem;
  height: 2rem;
  font-size: 1rem;
  &:disabled {
    background-color: lightgray;
  }
`;

export const CourseListItem = styled.li`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 0.5rem;
  border-top: 1px solid black;
  font-size: 1.5rem;
`;
